// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ZCmA svg{color:#13b27e;vertical-align:-7px}._1lNzZ{text-align:left}._2uy79{text-align:right}", ""]);
// Exports
exports.locals = {
	"feature": "_3ZCmA",
	"left": "_1lNzZ",
	"right": "_2uy79"
};
module.exports = exports;
